import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=18c78c2a&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=18c78c2a&prod&lang=scss&scoped=true"
import style1 from "./Area.vue?vue&type=style&index=1&id=18c78c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c78c2a",
  null
  
)

export default component.exports